import styled from '@mui/material/styles/styled'
import FormControlLabel from '@mui/material/FormControlLabel'
import Box from '@mui/material/Box'

export const SearchFormControlLabel = styled(FormControlLabel)({
  marginBottom: 'auto',
})

export const SearchFilterContainer = styled(Box)(({ theme }) => ({
  marginLeft: theme.spacing(),
  display: 'flex',
  flexWrap: 'wrap',
  justifyContent: 'space-between',
  height: '50px',
  [theme.breakpoints.down('md')]: {
    height: 'auto',
    marginBottom: theme.spacing(),
  },
  [theme.breakpoints.up('lg')]: {
    height: '50px',
  },
}))
